import { useEffect, useState } from "react";
import { inviteEvent } from "../../api/client";
import { validatePhoneNumber } from "../../utils/common";
import { useDispatch, useSelector } from "react-redux";
import { updateLoginModal } from "../../store/slicers/authSlice";
import { Modal } from "./Modal";
import AdImage from "../../assets/images/anyaya-ad.png";

export default function RSVPModal({ id, isOpen, onClose, type = "1" }) {
  const dispatch = useDispatch();
  const rsvp_details = useSelector((state) => state.auth.rsvp_details);
  const isLoggedIn = useSelector((state) => state.auth.token);
  const [guestName, setGuestName] = useState("");
  const [contactNo, setContactNo] = useState("");
  const [notes, setNotes] = useState("");
  const [isLoading, setLoading] = useState(false);
  const [showSentModal, setShowSentModal] = useState("");
  const [showAd, setShowAd] = useState(false);
  const [pendingAd, setPendingAd] = useState(false);

  useEffect(() => {
    if (rsvp_details) {
      setGuestName(rsvp_details.guest_name);
      setContactNo(rsvp_details.contact_no);
      setNotes(rsvp_details.notes);
    }
  }, [rsvp_details]);

  useEffect(() => {
    if (!showSentModal || showAd) return;

    const timer = setTimeout(() => {
      setShowSentModal("");
      if (pendingAd) {
        setShowAd(true);
        setPendingAd(false);
      }
    }, 1000);

    return () => clearTimeout(timer);
  }, [showSentModal, showAd, pendingAd]);

  // Submit RSVP
  const submitRSVP = async () => {
    try {
      setLoading(true);
      const _requestData = {
        event_code: id,
        flag: "save",
        guest_name: guestName,
        contact_no: contactNo,
        notes,
        status: type,
      };
      const response = await inviteEvent(_requestData);
      if (response.error === 0) {
        setLoading(false);
        setShowSentModal(response.msg);
        setPendingAd(true);
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  const titles = {
    1: "I’m Going",
    2: "Maybe",
    0: "Not Going",
  };

  const subtitles = {
    1: "",
    2: "We’ll keep you updated about the event.",
    0: "We’ll miss you at the event, but thanks for responding! Please leave your contact details so we can keep you updated.",
  };

  const buttonText = {
    1: "Confirm Attendance",
    2: "Submit",
    0: "Submit",
  };

  const APP_STORE_URL = "https://apps.apple.com/ph/app/anyaya-events-marketplace/id6744569510";
  const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.anyaya";

  const handleAdClick = () => {
    const userAgent = navigator.userAgent || "";
    const isAndroid = /android/i.test(userAgent);
    const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    const redirectUrl = isIOS
      ? APP_STORE_URL
      : isAndroid
      ? PLAY_STORE_URL
      : PLAY_STORE_URL;

    window.location.href = redirectUrl;
  };

  const handleClose = () => {
    setGuestName("");
    setContactNo("");
    setNotes("");
    setLoading(false);
    setShowAd(false);
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm p-4">
      {showAd ? (
        <div className="absolute inset-0 z-50 flex items-center justify-center p-4">
          <button
            type="button"
            onClick={handleAdClick}
            className="rounded-xl relative block w-full max-w-full p-0 border-0 bg-transparent"
          >
            <img
              src={AdImage}
              alt="Anyaya Ad"
              className="max-h-[calc(100vh-4rem)] w-full object-contain rounded-xl cursor-pointer"
            />
          </button>
        </div>
      ) : (
        <div className="w-[90%] max-w-md rounded-2xl bg-white border border-white/30 shadow-xl">
          {/* Header */}
          <div className="flex space-x-4 items-center px-5 pt-5">
            <button
              onClick={handleClose}
              className="text-gray-400 hover:text-gray-600"
            >
              ✕
            </button>
            <h2 className="text-lg font-semibold text-gray-900">
              {titles[type]}
            </h2>
          </div>

          {subtitles[type] && (
            <p className="px-5 mt-1 text-sm text-gray-500">{subtitles[type]}</p>
          )}

          {/* Form */}
          <div className="px-5 pb-6 pt-4 space-y-3">
            <div id="name" className="p-2 text-black border rounded-xl text-sm">
              <input
                value={guestName}
                onChange={(e) => {
                  setGuestName(e.target.value);
                }}
                placeholder="Your Name (First & Last)"
                className="resize-none border-none  outline-none w-full p-2 bg-transparent"
              />
            </div>

            <div
              id="phone"
              className={`text-black mt-2 p-2 flex items-center border rounded-xl text-sm rounded-xl text-sm`}
            >
              <span>+63</span>
              <input
                value={contactNo}
                onChange={(e) => {
                  setContactNo(validatePhoneNumber(e.target.value));
                }}
                className="resize-none border-none  outline-none w-full p-2 bg-transparent"
                placeholder="Contact Number (optional)"
              />
            </div>

            <div
              id="notes"
              className="p-2 text-black border rounded-xl text-sm"
            >
              <textarea
                value={notes}
                onChange={(e) => {
                  setNotes(e.target.value);
                }}
                rows={2}
                placeholder="Note"
                className="resize-none border-none  outline-none w-full p-2 bg-transparent"
              />
            </div>
            <button
              onClick={() => submitRSVP()}
              className="w-full rounded-lg bg-primary-500 px-4 py-3 text-white font-medium hover:bg-primary-700"
            >
              {buttonText[type]}
            </button>
          </div>
        </div>
      )}
      {showSentModal && !showAd && (
        <Modal
          disableNavigation={true}
          onClose={() => {
            setShowSentModal("");
            if (pendingAd) {
              setShowAd(true);
              setPendingAd(false);
            }
            // if (!isLoggedIn) {
            //   dispatch(
            //     updateLoginModal({
            //       status: true,
            //       navigate: "rsvp",
            //       rsvp_details: {
            //         contact_no: contactNo,
            //       },
            //     })
            //   );
            // }
          }}
          title={"rsvp"}
          description={showSentModal}
        />
      )}
    </div>
  );
}
